export default __webpack_public_path__ + "static/media/linkedin.d670df15.svg";